import React, { useEffect, useState } from "react";
import Footer from "../../Components/Footer/footer";
import performRequest from "../../api/request";
import { Toast } from "../../CustomComponent/toast";
import Pagination from "../../Components/layouts/pagination";
import getFilteredURL from "../../Components/Functions/filters.getUrl";
import DynamicFilterInput from "../../Components/layouts/filter.inpit";
import LoadingPage from "../../Components/layouts/loading";
import TaskManagementTable from "./Task Management/task_table";
import DynamicFilterSelect from "../../Components/layouts/filter.select";
import { useDispatch, useSelector } from "react-redux";
import { CustomErrorResponse } from "../../CustomComponent/custom_error_response";
import CustomCheckbox from "../../CustomComponent/custom_checkbox";
import { BsPatchPlus } from "react-icons/bs";
import { FcCalendar } from "react-icons/fc";

import {
  setCurrentPage,
  setReduxFilters,
} from "../../redux/Task/taskFilterReducer";

const TaskManagement = () => {
  const store = useSelector((store) => store.taskFilters);
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [filters, setFilters] = useState(store.filters);
  const [page, setCurrPage] = useState(store.currentPage);
  const [showPage, setShowPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const dispatch = useDispatch();
  const [data, setData] = useState([]);
  const [leadOwner, setLeadOwner] = useState();
  const [repeatableTasks, setRepeatableTasks] = useState([]);
  const [teamTasks, setTeamTasks] = useState([]);
  const [showCompleted, setShowCompleted] = useState(false);
  let userData = useSelector((store) => store.login.user);

  useEffect(() => {
    setLoading(true);
    const baseURL = getFilteredURL(
      "/tasks/getTaskManagement/",
      store.currentPage,
      store.filters
    );
    const url =
      userData.Role === process.env.REACT_APP_ROLE_ADMIN ||
      userData.Role === process.env.REACT_APP_ROLE_ADMIN_S ||
      userData.Role === process.env.REACT_APP_ROLE_SALES_MANAGER ||
      userData.Role === process.env.REACT_APP_ROLE_HR
        ? baseURL
        : `${baseURL}&assignTo=${userData.Name}&generatedBy=${userData.UserId}`;

    performRequest("GET", url)
      .then((res) => {
        if (res.status === 200) {
          setData(res.data);
          if (showCompleted) {
            sortData(
              res?.data?.repeatCompleteTasks,
              res?.data?.oneTimeCompleteTasks
            );
            setTotalPages(
              Math.ceil(res.data?.taskManagementCompleteCount / 50)
            ); 
          } else {
            sortData(res?.data?.repeatTasks, res?.data?.oneTimeTasks);
            setTotalPages(Math.ceil(res.data?.taskManagementCount / 50));
          }
        } else {
          Toast("error", "Error while getting Tasks!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [
    refresh,
    store.currentPage,
    userData.Role,
    userData.userName,
    showCompleted,
  ]);

  useEffect(() => {
    performRequest("GET", "/leads/getAllLeadsOwners")
      .then((res) => setLeadOwner(res?.data))
      .catch((err) => CustomErrorResponse(err));
  }, []);

  const sortData = (repeatTasks = [], oneTimeTasks = []) => {
    const priorityOrder = { P1: 1, P2: 2, P3: 3, "": 4 };

    const sortTasks = (tasks = []) => {
      let filteredData = filters.hideCompleted
        ? tasks.filter((item) => item.status !== "completed")
        : tasks;

      const pendingTasks = filteredData
        .filter((item) => item.status === "pending")
        .sort(
          (a, b) =>
            (priorityOrder[a.priority] || 4) - (priorityOrder[b.priority] || 4)
        );

      const completedTasks = filters.hideCompleted
        ? []
        : filteredData
            .filter((item) => item.status === "completed")
            .sort(
              (a, b) =>
                (priorityOrder[a.priority] || 4) -
                (priorityOrder[b.priority] || 4)
            );

      return [...pendingTasks, ...completedTasks];
    };

    setRepeatableTasks(sortTasks(repeatTasks || []));
    setTeamTasks(sortTasks(oneTimeTasks || []));
  };

  useEffect(() => {
    setCurrPage(store.currentPage);
    setShowPage(Math.floor((store.currentPage - 1) / 5) * 5 + 1);
  }, [store.currentPage]);
  const setPage = (p) => {
    dispatch(setCurrentPage(p));
  };
  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xl">
          <div className="page-header d-print-none">
            <div className="row align-items-center mb-3">
              <div className="col-md-8">
                <h2 className="page-title mb-1">
                  <FcCalendar className="fs-2  me-1" /> Task Tracking
                </h2>
                <h4 className="text-muted">
                  {/* <StepRoutes /> */} Allot, manage, track and update all
                  tasks.
                </h4>
              </div>
              <div className="col-md-4">
                <div className="btn-list justify-content-end">
                  {(userData?.Role === process.env.REACT_APP_ROLE_ADMIN_S ||
                    userData?.Role === process.env.REACT_APP_ROLE_ADMIN ||
                    userData?.Role ===
                      process.env.REACT_APP_ROLE_SALES_MANAGER ||
                    userData?.Role === process.env.REACT_APP_ROLE_IT ||
                    userData?.Role === process.env.REACT_APP_ROLE_PURCHASE ||
                    userData?.Role === process.env.REACT_APP_ROLE_ACCOUNTS ||
                    userData?.Role === process.env.REACT_APP_ROLE_AGRONOMIST ||
                    userData?.Role === process.env.REACT_APP_ROLE_OPS ||
                    userData?.Role === process.env.REACT_APP_ROLE_INSPECTION ||
                    userData?.Role === process.env.REACT_APP_ROLE_MARKETING ||
                    userData?.Role === process.env.REACT_APP_ROLE_SSM ||
                    userData?.Role === process.env.REACT_APP_ROLE_SALLE ||
                    userData?.Role === process.env.REACT_APP_ROLE_SALLE_ADMIN ||
                    userData?.Role ===
                      process.env.REACT_APP_ROLE_CLIENT_FEEDBACK ||
                    userData?.Role === process.env.REACT_APP_ROLE_HR ||
                    userData?.Role ===
                      process.env.REACT_APP_ROLE_SALESCOORDINATOR ||
                    userData?.Role === process.env.REACT_APP_ROLE_JR_HR) && (
                    <a href={"/task-management/new"}>
                      <button className="btn btn-primary d-none d-sm-block ">
                        <BsPatchPlus className="me-2 fs-2" /> ADD NEW TASK
                      </button>
                    </a>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-3 col-sm-12 py-2">
              <div className="card p-2">
                <div
                  id="faq-1"
                  className="accordion"
                  role="tablist"
                  aria-multiselectable="true"
                >
                  <div>
                    <div className="accordion-header m-0" role="tab">
                      <button
                        className="accordion-button fs-3 d-md-none p-0"
                        data-bs-toggle="collapse"
                        data-bs-target="#faq-1-1"
                      >
                        <h3 className="m-1">Filter result</h3>
                      </button>
                    </div>

                    <div
                      id="faq-1-1"
                      className="accordion-collapse collapse d-md-none"
                      role="tabpanel"
                      data-bs-parent="#faq-1"
                    >
                      <div className="accordion-body pt-0">
                        <div className="row">
                          <div className="col-12">
                            <DynamicFilterInput
                              label="Start Date:"
                              value={filters.startdate}
                              onChange={(e) => {
                                setFilters({
                                  ...filters,
                                  startdate: e.target.value,
                                });
                                dispatch(
                                  setReduxFilters({
                                    ...filters,
                                    startdate: e.target.value,
                                  })
                                );
                              }}
                              type="date"
                            />
                          </div>
                          <div className="col-12">
                            <DynamicFilterInput
                              label="End Date:"
                              value={filters.enddate}
                              onChange={(e) => {
                                setFilters({
                                  ...filters,
                                  enddate: e.target.value,
                                });
                                dispatch(
                                  setReduxFilters({
                                    ...filters,
                                    enddate: e.target.value,
                                  })
                                );
                              }}
                              type="date"
                            />
                          </div>
                          <div className="col-12">
                            <DynamicFilterSelect
                              label="Search by status:"
                              value={filters.status}
                              onChange={(e) => {
                                setFilters({
                                  ...filters,
                                  status: e.target.value,
                                });
                                dispatch(
                                  setReduxFilters({
                                    ...filters,
                                    status: e.target.value,
                                  })
                                );
                              }}
                            >
                              <option value="">Select</option>
                              <option value="pending">Pending</option>
                              <option value="completed">Completed</option>
                            </DynamicFilterSelect>
                            {(userData.Role ===
                              process.env.REACT_APP_ROLE_ADMIN_S ||
                              userData.Role ===
                                process.env.REACT_APP_ROLE_ADMIN ||
                              userData.Role === process.env.REACT_APP_ROLE_HR ||
                              userData.Role ===
                                process.env.REACT_APP_ROLE_JR_HR) && (
                              <DynamicFilterSelect
                                label="Search by assign:"
                                value={filters.assignTo}
                                onChange={(e) => {
                                  setFilters({
                                    ...filters,
                                    assignTo: e.target.value,
                                  });
                                  dispatch(
                                    setReduxFilters({
                                      ...filters,
                                      assignTo: e.target.value,
                                    })
                                  );
                                }}
                              >
                                <option value="">Select</option>

                                {leadOwner &&
                                  leadOwner?.map((state, index) => (
                                    <option key={index} value={state?.userName}>
                                      {state?.userName}
                                    </option>
                                  ))}
                              </DynamicFilterSelect>
                            )}
                            {/* <div className="form-check">
                              <input
                                type="checkbox"
                                className="form-check-input"
                                id="upcomingTask"
                                name="email"
                                checked={filters.upcomingTask || false}
                                onChange={(e) => {
                                  setFilters({
                                    ...filters,
                                    upcomingTask: e.target.checked,
                                  });
                                  dispatch(
                                    setReduxFilters({
                                      ...filters,
                                      upcomingTask: e.target.checked,
                                    })
                                  );
                                }}
                              />
                              <label
                                className="form-check-label"
                                htmlFor="upcomingTask"
                              >
                                Upcoming Tasks
                              </label>
                            </div> */}
                            {/* <div className="form-check">
                            <input
                              type="checkbox"
                              className="form-check-input"
                              id="upcomingTask"
                              name="email"
                              checked={filters.upcomingTask || false}
                              onChange={(e) =>
                                setFilters({
                                  ...filters,
                                  upcomingTask: e.target.checked,
                                })
                              }
                            />
                            <label
                              className="form-check-label"
                              htmlFor="upcomingTask"
                            >
                              Upcoming Tasks
                            </label>
                          </div> */}
                          </div>
                          <div className="col-12">
                            <DynamicFilterSelect
                              label="Select Priority:"
                              value={filters.priority}
                              onChange={(e) => {
                                setFilters({
                                  ...filters,
                                  priority: e.target.value,
                                });
                                dispatch(
                                  setReduxFilters({
                                    ...filters,
                                    priority: e.target.value,
                                  })
                                );
                              }}
                            >
                              <option value="">Select</option>
                              <option value="P1">P1</option>
                              <option value="P2">P2</option>
                              <option value="P3">P3</option>
                            </DynamicFilterSelect>
                          </div>
                          {/* <div className="form-check mt-2">
                            <input
                              type="checkbox"
                              className="form-check-input"
                              id="hideCompleted"
                              checked={filters.hideCompleted}
                              onChange={(e) => {
                                setFilters({
                                  ...filters,
                                  hideCompleted: e.target.checked,
                                });
                                dispatch(
                                  setReduxFilters({
                                    ...filters,
                                    hideCompleted: e.target.checked,
                                  })
                                );
                              }}
                            />
                            <label
                              className="form-check-label"
                              htmlFor="hideCompleted"
                            >
                              Hide Completed Tasks
                            </label>
                          </div> */}

                          <div className="col-12">
                            <div className="row mt-2">
                              <div className="col-6">
                                <button
                                  onClick={() => {
                                    dispatch(setCurrentPage(1));
                                    setRefresh(!refresh);
                                  }}
                                  className="btn btn-success w-100"
                                >
                                  Apply Filter
                                </button>
                              </div>
                              <div className="col-6">
                                <button
                                  onClick={() => {
                                    dispatch(
                                      setReduxFilters({
                                        startdate: "",
                                        enddate: "",
                                        status: "",
                                        assignTo: "",
                                        priority: "",
                                        upcomingTask: false,
                                        // hideCompleted: false,
                                      })
                                    );
                                    setFilters({
                                      startdate: "",
                                      enddate: "",
                                      status: "",
                                      assignTo: "",
                                      priority: "",
                                      upcomingTask: false,
                                      // hideCompleted: false,
                                    });
                                    setRefresh(!refresh);
                                  }}
                                  className="btn btn-secondary w-100"
                                >
                                  Reset Filter
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="accordion-body d-none d-md-block">
                      <div className="row">
                        <h3>Filter result</h3>
                        <div className="col-12">
                          <DynamicFilterInput
                            label="Start Date:"
                            value={filters.startdate}
                            onChange={(e) => {
                              setFilters({
                                ...filters,
                                startdate: e.target.value,
                              });
                              dispatch(
                                setReduxFilters({
                                  ...filters,
                                  startdate: e.target.value,
                                })
                              );
                            }}
                            type="date"
                          />
                        </div>
                        <div className="col-12">
                          <DynamicFilterInput
                            label="End Date:"
                            value={filters.enddate}
                            onChange={(e) => {
                              setFilters({
                                ...filters,
                                enddate: e.target.value,
                              });
                              dispatch(
                                setReduxFilters({
                                  ...filters,
                                  enddate: e.target.value,
                                })
                              );
                            }}
                            type="date"
                          />
                        </div>
                        <div className="col-12">
                          <DynamicFilterSelect
                            label="Search by status:"
                            value={filters.status}
                            onChange={(e) => {
                              setFilters({
                                ...filters,
                                status: e.target.value,
                              });
                              dispatch(
                                setReduxFilters({
                                  ...filters,
                                  status: e.target.value,
                                })
                              );
                            }}
                          >
                            <option value="">Select</option>
                            <option value="pending">Pending</option>
                            <option value="completed">Completed</option>
                          </DynamicFilterSelect>
                          {(userData.Role ===
                            process.env.REACT_APP_ROLE_ADMIN_S ||
                            userData.Role ===
                              process.env.REACT_APP_ROLE_ADMIN ||
                            userData.Role === process.env.REACT_APP_ROLE_HR ||
                            userData.Role ===
                              process.env.REACT_APP_ROLE_JR_HR) && (
                            <DynamicFilterSelect
                              label="Search by assign:"
                              value={filters.assignTo}
                              onChange={(e) => {
                                setFilters({
                                  ...filters,
                                  assignTo: e.target.value,
                                });
                                dispatch(
                                  setReduxFilters({
                                    ...filters,
                                    assignTo: e.target.value,
                                  })
                                );
                              }}
                            >
                              <option value="">Select</option>

                              {leadOwner &&
                                leadOwner?.map((state, index) => (
                                  <option key={index} value={state?.userName}>
                                    {state?.userName}
                                  </option>
                                ))}
                            </DynamicFilterSelect>
                          )}
                          {/* <div className="form-check">
                            <input
                              type="checkbox"
                              className="form-check-input"
                              id="upcomingTask"
                              name="email"
                              checked={filters.upcomingTask || false}
                              onChange={(e) => {
                                setFilters({
                                  ...filters,
                                  upcomingTask: e.target.checked,
                                });
                                dispatch(
                                  setReduxFilters({
                                    ...filters,
                                    upcomingTask: e.target.checked,
                                  })
                                );
                              }}
                            />
                            <label
                              className="form-check-label"
                              htmlFor="upcomingTask"
                            >
                              Upcoming Tasks
                            </label>
                          </div> */}
                        </div>
                        <div className="col-12">
                          <DynamicFilterSelect
                            label="Select Priority:"
                            value={filters.priority}
                            onChange={(e) => {
                              setFilters({
                                ...filters,
                                priority: e.target.value,
                              });
                              dispatch(
                                setReduxFilters({
                                  ...filters,
                                  priority: e.target.value,
                                })
                              );
                            }}
                          >
                            <option value="">Select</option>
                            <option value="P1">P1</option>
                            <option value="P2">P2</option>
                            <option value="P3">P3</option>
                          </DynamicFilterSelect>
                        </div>

                        {/* <div className="form-check mt-2 ms-2">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id="hideCompleted"
                            checked={filters.hideCompleted}
                            onChange={(e) => {
                              setFilters({
                                ...filters,
                                hideCompleted: e.target.checked,
                              });
                              dispatch(
                                setReduxFilters({
                                  ...filters,
                                  hideCompleted: e.target.checked,
                                })
                              );
                            }}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="hideCompleted"
                          >
                            Hide Completed Tasks
                          </label>
                        </div> */}

                        <div className="col-12">
                          <div className="row mt-2">
                            <div className="col-6">
                              <button
                                onClick={() => {
                                  dispatch(setCurrentPage(1));
                                  setRefresh(!refresh);
                                }}
                                className="btn btn-success w-100"
                              >
                                Apply Filter
                              </button>
                            </div>
                            <div className="col-6">
                              <button
                                onClick={() => {
                                  dispatch(
                                    setReduxFilters({
                                      startdate: "",
                                      enddate: "",
                                      status: "",
                                      assignTo: "",
                                      priority: "",
                                      upcomingTask: false,
                                      // hideCompleted: false,
                                    })
                                  );
                                  setFilters({
                                    startdate: "",
                                    enddate: "",
                                    status: "",
                                    assignTo: "",
                                    priority: "",
                                    upcomingTask: false,
                                    // hideCompleted: false,
                                  });
                                  setRefresh(!refresh);
                                }}
                                className="btn btn-secondary w-100"
                              >
                                Reset Filter
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="mt-2 text-center">
                <button
                  className={`btn ${
                    showCompleted ? "btn-success" : "btn-outline-success"
                  } w-100`}
                  onClick={() => {
                    setShowCompleted(!showCompleted);
                    dispatch(setCurrentPage(1));
                  }}
                >
                  {showCompleted ? "Show Pending Tasks" : "Completed Tasks"}
                </button>
              </div>
            </div>

            <div className="col-md-9 col-sm-12">
              <div className="mt-2">
                <div className="row">
                  {/* Repeatable Tasks Card */}
                  <div className="col-md-6">
                    <div
                      className="card p-3"
                      style={{ height: "600px", overflow: "hidden" }}
                    >
                      <h4 className="mb-3">Repeatable Tasks</h4>
                      <TaskManagementTable
                        data={repeatableTasks}
                        currentPage={page}
                        itemsPerPage={50}
                      />
                    </div>
                  </div>

                  {/* Team Tasks Card */}
                  <div className="col-md-6">
                    <div
                      className="card p-3"
                      style={{ height: "600px", overflow: "hidden" }}
                    >
                      <h4 className="mb-3">Team Tasks</h4>
                      <TaskManagementTable
                        data={teamTasks}
                        currentPage={page}
                        itemsPerPage={50}
                      />
                    </div>
                  </div>
                </div>

                <div className="btn-list justify-content-center">
                  <a href={"/task-management/new"}>
                    <button className="btn btn-primary d-lg-none d-md-none mt-3 mb-3">
                      <BsPatchPlus className="me-2 fs-2" /> ADD NEW TASK
                    </button>
                  </a>
                </div>

                <div className="card mt-2">
                  <Pagination
                    page={page}
                    setPage={setPage}
                    totalPages={totalPages}
                    pageDatalength={data?.taskManagementData?.length}
                    showPage={showPage}
                    setShowPage={setShowPage}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default TaskManagement;
